"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rudderReporter = exports.Framework = exports.ACTION_STATUS_RETIRED = exports.RUDDER_DESTINATIONS = exports.SupportedRudderstackIntegrations = void 0;
var transformPropsWithoutPrefix_1 = require("../transformers/transformPropsWithoutPrefix");
var LoggerFactory_1 = require("../utils/LoggerFactory");
var getWindow = function () { return window; };
/**
 * Enum representing the RudderStack integration currently supported by this reporter
 */
var SupportedRudderstackIntegrations;
(function (SupportedRudderstackIntegrations) {
    SupportedRudderstackIntegrations["ADOBE_ANALYTICS"] = "Adobe Analytics";
    SupportedRudderstackIntegrations["AMAZON_KINESIS"] = "Amazon Kinesis";
    SupportedRudderstackIntegrations["AWS_EVENTBRIDGE"] = "AWS EventBridge";
    SupportedRudderstackIntegrations["AWS_LAMBDA"] = "AWS Lambda";
    SupportedRudderstackIntegrations["GOOGLE_ANALYTICS"] = "Google Analytics";
    SupportedRudderstackIntegrations["INTERCOM"] = "Intercom";
    SupportedRudderstackIntegrations["MARKETO"] = "Marketo";
    SupportedRudderstackIntegrations["MIX_PANEL"] = "Mixpanel";
    SupportedRudderstackIntegrations["SALESFORCE"] = "Salesforce";
    SupportedRudderstackIntegrations["SNOWFLAKE"] = "Snowflake";
    SupportedRudderstackIntegrations["Pendo"] = "Pendo";
})(SupportedRudderstackIntegrations = exports.SupportedRudderstackIntegrations || (exports.SupportedRudderstackIntegrations = {}));
/**
 * Metrics destinations
 */
exports.RUDDER_DESTINATIONS = Object.freeze(__assign({}, SupportedRudderstackIntegrations));
exports.ACTION_STATUS_RETIRED = 'retired';
var Framework;
(function (Framework) {
    Framework["REACT"] = "react";
    Framework["NEXTJS"] = "nextjs";
})(Framework = exports.Framework || (exports.Framework = {}));
/**
 * Function to initialize rudder stack. For local development we initialize it
 * with debug mode. By default the latest version of this function will load the
 * deprecated RS SDK if the sdkVersion is not provided by the consumer
 *
 */
var LOG = LoggerFactory_1.LoggerFactory.create('RudderStackLogger');
/**
 * Rudderstack reporter, if rudderstack was initialized and the action destination
 * is supported by our rudderstack integration then we track it.
 *
 * @param type The type of action to log. I.e. page_load
 * @param data The data we want to send to
 * @param options Config options to override default behaviour
 */
var rudderReporter = function (id, data, options, callback) {
    if (data === void 0) { data = undefined; }
    var destinations = (data || {
        destinations: undefined // if no destinations is set means sent to all available destinations
    }).destinations;
    /**
     * Specify the integrations this event should be setup for. E.g. { All: false, MIXPANEL: true, INTERCOM: false,
     * SNOWFLAKE: true }
     * If the integrations are overriden by the configuration options use those as is. If not, we need to compute them
     * based on the destinations array passed.
     */
    var hasIntegrationOverrides = (options === null || options === void 0 ? void 0 : options.integrations) && Object.keys(options === null || options === void 0 ? void 0 : options.integrations).length > 0;
    var integrations = hasIntegrationOverrides
        ? __assign(__assign({}, options.integrations), { All: false }) : { All: !destinations };
    // if destinations is set and we have no integrations overrides we need to set the integrations based on destinations
    if (destinations && !hasIntegrationOverrides) {
        Object.values(SupportedRudderstackIntegrations).forEach(function (integration) {
            // set the integration to true only if it is included in the destinations
            integrations[integration] = destinations.includes(integration);
        });
    }
    // if there's at least one integration enabled the continue; otherwise just skip
    if (!Object.values(integrations).some(function (enabled) { return enabled; }) || (options && options.status === exports.ACTION_STATUS_RETIRED)) {
        return;
    }
    var rudderanalytics = getWindow().rudderanalytics;
    if (hasIntegrationOverrides)
        options === null || options === void 0 ? true : delete options.integrations;
    var metadata = (options === null || options === void 0 ? void 0 : options.metadata) || {};
    options === null || options === void 0 ? true : delete options.metadata;
    // These are the actions that are managed by the cdp framework
    var cdpActions = ['page_load', 'update_profile_with_custom_traits'];
    // Check if the action is passing the trackingPlanName in the options/data and append it to the cdpActions names if so
    var trackingPlanName = (options === null || options === void 0 ? void 0 : options.trackingPlanName) || (data === null || data === void 0 ? void 0 : data.trackingPlanName);
    var actionName = trackingPlanName && cdpActions.includes(id) ? "".concat(trackingPlanName, " ").concat(id) : id;
    if (rudderanalytics) {
        // Remove the cvent_ prefix from the data as this is only for Datadog
        var finalData = (0, transformPropsWithoutPrefix_1.transformAndRemoveCventPrefix)(data);
        var pathname = finalData === null || finalData === void 0 ? void 0 : finalData.pathname;
        try {
            if (id === 'page_load') {
                var title = typeof document.title === 'undefined' || document.title === '' ? pathname === null || pathname === void 0 ? void 0 : pathname.replace('/', '') : document.title;
                rudderanalytics.track(actionName, __assign(__assign({}, finalData), { title: title, downstreamName: 'page_load' }), __assign(__assign({}, options), metadata));
            }
            else {
                rudderanalytics.track(actionName, finalData, __assign(__assign(__assign({}, options), metadata), { integrations: integrations }));
            }
            var actionPayload = { id: actionName, data: finalData, options: __assign(__assign(__assign({}, options), metadata), { integrations: integrations }) };
            LOG.debug('Action sent to Rudderstack >>>>>', JSON.stringify(actionPayload));
            if (callback)
                callback('rudderStackReporter', actionPayload);
        }
        catch (error) {
            LOG.error(error.message);
        }
    }
    else {
        LOG.debug("Rudderstack was never initialized. Therefore ".concat(actionName, " action was not sent >>>>"), data);
    }
};
exports.rudderReporter = rudderReporter;
